export default __webpack_public_path__ + "static/media/banner-mobile.b100adb1.png";